<template>
  <div id="empresa-producao">
 
    <section id="content">
      <!--start container-->
      <div class="container">
        <TituloPagina titulo="Produção mês a mês" />
        <div class="row">
          <div class="col s12 m12 l12">
            <div class="card-panel-1">
              <div class="col s12 m12 l12">
                <h4>Informações da empresa</h4>
              </div>

                <div class="input-field col s12 m6 l4">
                    <label for="status_fantasia" class="active">Nome fantasia</label>              
                    <input id="status_fantasia" :readonly="true" :value="nome_fantasia" class="validate" />
                </div>

                <div class="input-field col s12 m6 l1">
                    <label for="status_id" class="active">Id</label>              
                    <input id="status_id" :value="paramsId" :readonly="true" class="validate" />
                </div>

                <div class="input-field col s12 m6 l2">
                    <label for="status_cpnj" class="active">CNPJ</label>              
                    <input id="status_cpnj" :readonly="true" :value="cnpj" class="validate" />
                </div>

                <div class="input-field col s12 m6 l5">
                    <label for="status_social" class="active">Razão Social</label>              
                    <input id="status_social" :readonly="true" :value="razao_social"  class="validate" />
                </div>

                <div class="input-field col s12 m6 l2">
                    <label for="data_inicio" class="active">Data inicio</label>
                    <date-picker id="data_inicio" v-model="filtro.data_ini" format="DD/MM/YYYY" input-class="m-0" class="width-100"></date-picker>
                </div>

                <div class="input-field col s12 m6 l2">
                    <label for="data_fim" class="active">Data Fim</label>
                    <date-picker id="data_fim" v-model="filtro.data_fim" format="DD/MM/YYYY" input-class="m-0" class="width-100"></date-picker>
                </div>

                <div class="input-field col s12 m6 l4">
                    <button class="btn btn-default" >Filtrar data relatório</button>
                </div>
              
            </div>
          </div>
        </div>
      </div>
      <!--end container-->
    </section>
  </div>
</template>
<script>

import TituloPagina from "@/components/common/TituloPagina";
import getPalavra from "@/helpers/language";
import { api } from '@/helpers/api';

export default {
    components: {
        TituloPagina,
    },

    data: () => ({
        nome_fantasia: null,
        razao_social: null,
        cnpj: null,
        paramsId: null,
        filtro:{
            data_ini: moment().subtract(90, 'days').toDate(),
            data_fim: new Date,
            order: 'desc'
        },

        lang: {
            empresa: getPalavra("empresa", false, true),
        },
    }),


    created: function () {
        this.getParams();
    },


    methods: {
        getParams() {
            let self = this;
            self.paramsId = self.$route.params.id;

            console.log('SELF: ', self.paramsId)

            api.get('empresa').then(response => {
                /* console.log(response.data.result.data.data) */
                const data = response.data.result.data.data
                const companyFiltered = data.filter( empresa => empresa.empresa_id == self.paramsId )
                console.log('COMPANY FILTER:', companyFiltered[0].empresa_nome_fantasia);

                this.nome_fantasia = companyFiltered[0].empresa_nome_fantasia;
                this.razao_social = companyFiltered[0].empresa_razao_social;
                this.cnpj = companyFiltered[0].empresa_cnpj;

                console.log('DATA: ', this.nome_fantasia)
            })

        }
    },
};
</script>
<!-- New step!
     Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scopped>
.cyan {
  background-color: #44a3ac;
  color: #fff;
}

.btn-outlined {
  background: transparent;
  border: 1px solid #44a3ac;
  color: #44a3ac;
  box-shadow: none;
}

.btn-outlined:hover {
  background: transparent;
}

.left {
  margin-right: 10px;
}

.card-panel-1 {
    height: 300px;
    width: 100%;
    background-color: #fff;
    box-shadow: 0 0 1em #ccc;
    border-radius: 5px;
    padding: 2%;
}



</style>




// WEBPACK FOOTER //
// src/components/empresas/Producao.vue